module.exports = __webpack_public_path__ + "media/home-video.429616e8.mp4";